<div class="tracker-main">
    <div class="container start-container">
        <div class="row mt50">
            <div class="col-sm-6">
                <div class="left-part">
                    <em class="icon-icn-car-config font100 text-primary"></em>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="right-part">
                    <label translate>
                        lblCheckInFailed
                    </label>
                    <div class="loginlp">
                        <div class="licence-pl ">
                            <input type="text" class="center" value="!400" />
                        </div>
                    </div>
                    <a href="javascript:void(0);" class="btn bluebtn" (click)="moveNext()" translate>Back To Start</a>
                </div>
            </div>
        </div>
    </div>
</div>